import { render, staticRenderFns } from "./text-area-editor-field.vue?vue&type=template&id=99419160&"
import script from "./text-area-editor-field.vue?vue&type=script&lang=js&"
export * from "./text-area-editor-field.vue?vue&type=script&lang=js&"
import style0 from "./text-area-editor-field.vue?vue&type=style&index=0&id=99419160&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports